import { render, staticRenderFns } from "./ServicesSection.vue?vue&type=template&id=3b8630ce&scoped=true&"
import script from "./ServicesSection.vue?vue&type=script&lang=js&"
export * from "./ServicesSection.vue?vue&type=script&lang=js&"
import style0 from "./ServicesSection.vue?vue&type=style&index=0&id=3b8630ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8630ce",
  null
  
)

export default component.exports